import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Establishment admin: upload the entity's approved logo file as-is (PNG / JPG / WEBP). SUNTRONIX keeps its locked logo. */
export function EntityLogoField({ est, onSaved }) {
  const [busy, setBusy] = useState(false);
  const primary = est.is_primary || est.id === "est_suntronix";
  const logo = est.branding?.logo;
  const upload = async (f) => {
    if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    setBusy(true);
    try { const { data } = await api.post(`/establishments/${est.id}/logo`, fd); toast.success("Logo saved"); onSaved?.(data.logo); }
    catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); }
    setBusy(false);
  };
  return (
    <div className="rounded-lg border border-slate-200 p-3 text-[12px]" data-testid="establishment-logo-field">
      <div className="font-semibold text-slate-800">Approved logo</div>
      {primary ? <div className="text-slate-500" data-testid="establishment-logo-locked">SUNTRONIX official logo is brand-locked (managed in code, not replaceable here).</div> : (
        <div className="mt-1 flex flex-wrap items-center gap-3">
          {logo?.sha256 ? <img src={`${BACKEND}/api/establishments/${est.id}/logo?v=${logo.sha256.slice(0, 12)}`} alt="logo" className="h-10 max-w-[180px] object-contain" data-testid="establishment-logo-preview" />
            : <span className="rounded bg-amber-50 px-2 py-1 font-semibold text-amber-800" data-testid="establishment-logo-missing">No approved logo yet — header shows the company name</span>}
          <label className="cursor-pointer rounded border border-slate-300 px-2 py-1 font-semibold">{busy ? "Uploading…" : logo?.sha256 ? "Replace logo" : "Upload logo"}
            <input type="file" accept=".png,.jpg,.jpeg,.webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="establishment-logo-input" /></label>
          <span className="text-slate-400">Upload the approved file exactly as provided — it is shown as-is, never recropped or recoloured.</span>
        </div>)}
    </div>
  );
}
